import { css } from '@emotion/core'
import React from 'react'
import { AddChildButton, AddSpouseUnknownPositionButton, AddParentButton } from '@fs/zion-add-find-flow'
import { Divider } from '@fs/zion-ui'
import { useFamilyColumnValues } from '../../../contexts/FamilyColumnContext'

const indentCss = css`
  padding-inline-start: 35px; /** to match exactly with children list */
`

export default function ButtonsSkeleton(): JSX.Element {
  const { type } = useFamilyColumnValues()

  return (
    <>
      {type === 'spouses' && (
        <>
          <div css={indentCss}>
            {/* eslint-disable-next-line test-selectors/button -- NA */}
            <AddSpouseUnknownPositionButton disabled emphasis="inline" excludeChildren relatedSpouse={{}} />
          </div>
          <Divider marginY="xxs" />
          <div css={indentCss}>
            {/* eslint-disable-next-line test-selectors/button -- NA */}
            <AddChildButton disabled />
          </div>
        </>
      )}
      {type === 'parents' && (
        <div css={indentCss}>
          {/* eslint-disable-next-line test-selectors/button -- NA */}
          <AddParentButton disabled relatedChild={{}} />
        </div>
      )}
    </>
  )
}
